import { ArticlesList } from '../../components';
import { withLayout } from '../../Layout/Layout';
import Head from 'next/head';
import React from 'react';

function Articles() {
  return (
    <>
      <Head>
        <meta
          name="description"
          content={
            'Find exclusive airline offers and deals on First-Class.com. Discover discounts and promotions for your next premium travel adventure'
          }
        />
        <title>Airline Offers: Exclusive Deals for Luxury Travel</title>
      </Head>
      <ArticlesList subtype="Offers" type="Airlines" />
    </>
  );
}

export default withLayout(Articles, true);
